/*=========================================================================================
  File Name: vendorcertifications.store.js
  Namespace: vendorcertifications
  Description: Vuex External Vendor Certification Store
==========================================================================================*/
import {
  createVendorCertification,
  listVendorCertifications
} from '@/services/vendorcertifications.service.js'
import CONSTANTS from '@/constants'

const { PUBLISHED, UNPUBLISHED } = CONSTANTS.CERTIFICATION_STATUSES

const state = {
  vendorCertificationList: {}
}

function toEntries(results = []) {
  return results.reduce((acc, certification) => {
    const id = certification.id || certification.uuid
    if (!id) return acc
    acc[id] = {
      id,
      certification_name: certification.certification_name,
      vendor_name: certification.vendor_name,
      status: certification.status
    }
    return acc
  }, {})
}

const getters = {
  getVendorCertifications(state) {
    return Object.values(state.vendorCertificationList).map((certification) => ({
      label: `${certification.vendor_name || 'Unknown vendor'} - ${
        certification.certification_name
      }${certification.status === UNPUBLISHED ? ' (unpublished)' : ''}`,
      value: certification.id,
      status: certification.status
    }))
  },
  getVendorCertificationEntries(state) {
    return state.vendorCertificationList
  }
}

const mutations = {
  STORE_VENDOR_CERTIFICATIONS(state, results) {
    state.vendorCertificationList = {
      ...state.vendorCertificationList,
      ...toEntries(results)
    }
  },
  RESET_VENDOR_CERTIFICATIONS(state) {
    state.vendorCertificationList = {}
  }
}

const actions = {
  async getAllVendorCertifications({ commit }, params = {}) {
    const response = await listVendorCertifications({
      status: PUBLISHED,
      page_size: 256,
      ...params
    })
    if (response) {
      commit('STORE_VENDOR_CERTIFICATIONS', response.results)
    }
    return response
  },
  async createVendorCertification({ commit }, payload) {
    const response = await createVendorCertification(payload)
    if (response) {
      commit('STORE_VENDOR_CERTIFICATIONS', [response])
    }
    return response
  },
  // Unpublished associations are never in the published list, so seed them
  // or their chips render as raw ids.
  seedVendorCertifications({ commit }, certifications = []) {
    commit('STORE_VENDOR_CERTIFICATIONS', certifications)
  },
  resetVendorCertifications({ commit }) {
    commit('RESET_VENDOR_CERTIFICATIONS')
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
